<div class="filtros-container">
  <!-- Controles de filtro -->
  <ng-container *ngFor="let filtro of config">
    <ng-container [ngSwitch]="filtro.type">
      <!-- Filtro de fecha única -->
      <mat-form-field *ngSwitchCase="'date'" [appearance]="filtro.appearance || 'outline'">
        <mat-label>{{filtro.label}}</mat-label>
        <input matInput [matDatepicker]="picker" 
               [formControl]="filtrosForm.get(filtro.key)"
               [min]="filtro.minDate" [max]="filtro.maxDate"
               (dateChange)="onDateChange(filtro.key, $event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <!-- Filtro de rango de fechas -->
      <mat-form-field *ngSwitchCase="'date-range'" [appearance]="filtro.appearance || 'outline'">
        <mat-label>{{filtro.label}}</mat-label>
        <mat-date-range-input [formGroup]="filtrosForm.get(filtro.key)" [rangePicker]="pickerRange">
          <input matStartDate formControlName="date_from" placeholder="Fecha inicio">
          <input matEndDate formControlName="date_to" placeholder="Fecha fin">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerRange></mat-date-range-picker>
      </mat-form-field>
      <!-- Selector simple -->
      <mat-form-field *ngSwitchCase="'single-select'" [appearance]="filtro.appearance || 'outline'">
        <mat-label>{{filtro.label}}</mat-label>
        <mat-select [formControl]="filtrosForm.get(filtro.key)" 
                    [multiple]="false"
                    [compareWith]="compareFn"
                    (selectionChange)="onSelectionChange(filtro.key, $event.value)">
          <mat-option>TODOS</mat-option>
          <mat-option *ngFor="let option of filtro.options" [value]="option">
            {{filtro.optionLabel ? option[filtro.optionLabel] : option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Selector múltiple -->
      <mat-form-field *ngSwitchCase="'multi-select'" [appearance]="filtro.appearance || 'outline'">
        <mat-label>{{filtro.label}}</mat-label>
    <mat-select 
      [formControl]="filtrosForm.get(filtro.key)" 
      [multiple]="filtro.multiple || false"
      [compareWith]="compareFn"
      (selectionChange)="onSelectionChange(filtro.key, $event.value)">
      
      <mat-option>TODOS</mat-option>
      <mat-option *ngFor="let option of filtro.options" [value]="option">
        {{filtro.optionLabel ? option[filtro.optionLabel] : option}}
      </mat-option>
      
      <ng-container *ngIf="filtro.showButtons && filtro.multiple">
        <div class="row no-gutters pb-1">
          <hr>
          <div class="actividad-btn-action col-sm-6 text-center pr-2 pb-1">
            <button mat-flat-button type="button" color="primary" 
                    (click)="filtrosForm.get(filtro.key).reset()">
              Cancelar
            </button>
          </div>
          <div class="actividad-btn-action col-sm-6 text-center pr-2 pb-1">
            <button mat-flat-button color="accent" type="button"
                    (click)="confirmSelection(filtro.key)">
              Ok
            </button>
          </div>
        </div>
      </ng-container>
    </mat-select>
      </mat-form-field>
    </ng-container>
  </ng-container>
</div>
<!-- Chips de filtros activos -->
<div class="chips-container">
  <mat-chip-list aria-label="Filters selection" class="pt-2 pb-3">
    <mat-chip *ngFor="let chip of activeChips" 
              (removed)="removeChip(chip.key)"
              [class]="chip.key">
      {{chip.chipLabel}}: {{chip.value}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-list>
</div>